/**
 *  InputSmall script file
**/

import i18n from '@/i18n'

export default {
  name: 'InputSmall',
  mixins: [],
  components: {},
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    defaultValue: {
      type: [String, Number],
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    pattern: {
      type: RegExp,
      required: false
    },
    maxlength: {
      type: String,
      required: false
    },
    max: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      required: false
    },
    step: {
      type: Number,
      required: false
    },
    minlength: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    error: {
      type: String,
      required: false
    },
    validateThreshold: {
      type: Number,
      default: 3
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      active: false,
      focus: false,
      fieldError: null
    }
  },
  computed: {
    hasValue () {
      return this.value || this.value === 0
    },
    input () {
      return this.$refs.input
    }
  },
  methods: {
    onFocus () {
      this.focus = true
      this.active = true
      this.$refs.input.focus()
    },
    onBlur () {
      this.focus = false
      if (!this.hasValue) {
        this.active = false
      }
    },
    clear () {
      this.$nextTick(() => {
        this.$emit('input', '')
        this.$refs.input.focus()
      })
    },
    getError () {
      if (this.error) {
        return this.error
      }

      const input = this.$refs.input
      if (!input) {
        return false
      }
      if (input.value && input.value.length < this.validateThreshold) {
        return false
      }
      if (input.validity.valueMissing) {
        return i18n.t('MANDATORY_FIELD')
      }
      if (input.validity.badInput || input.validity.typeMismatch || input.validity.patternMismatch) {
        return i18n.t('INVALID_FORMAT')
      }
      if (input.validity.tooLong) {
        return i18n.t('INPUT_ERROR_MAX_LENGTH', { n: this.maxlength })
      }
      if (input.validity.tooShort) {
        return i18n.t('INPUT_ERROR_MIN_LENGTH', { n: this.minlength })
      }
      if (this.type === 'number' && this.max && input.value.length > parseInt(this.max)) {
        return i18n.t('INPUT_ERROR_MAX_LENGTH', { n: this.maxlength })
      }
    }
  },
  watch: {
    value () {
      if (this.value !== this.$refs.input.value) {
        this.$refs.input.value = this.value
      }
      this.fieldError = this.getError()
    }
  }
}
